

import Routers from './allRoutes/Routes';
import './App.css';

function App() {
  return (
    <div className="App">
     <Routers/>
    </div>
  );
}

export default App;


